<div bsModal #acceptConditions="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="closeModal()" data-dismiss="modal" aria-hidden="true"
                    style="position:absolute; right:20px;">&times;</button>
                <h4 class="modal-title">Términos y condiciones</h4>
            </div>
            <div class="modal-body alto50vh f12">
                <h4>PLATAFORMA ELECTRÓNICA DE ICONSTRUYE S.A.</h4>
                <p>Bienvenido a la plataforma electrónica de Iconstruye S.A.</p>
                <p>El uso de esta plataforma está sujeta a los presentes Términos y Condiciones de Uso (en adelante
                    indistintamente, “Términos de Uso”) los cuales usted debe leer con detención. Lo señalado en estos
                    Términos
                    de Uso respecto de Iconstruye S.A., (en adelante indistintamente, “Iconstruye”) debe entenderse
                    también
                    referido a sus directores, representantes, gerentes, contratistas y empleados.</p>
                <hr>
                <h4>Acerca de la plataforma electrónica</h4>
                <p>Iconstruye es una empresa que ha desarrollado una plataforma electrónica que reúne a los diversos
                    actores de
                    la construcción, con el objeto que puedan efectuar transacciones en línea. Para esos efectos,
                    Iconstruye ha
                    implementado un sistema informático original, consistente en una plataforma electrónica con todas
                    las
                    funcionalidades y aplicaciones de un portal o foro de comercio, orientado a las compras y ventas de
                    productos
                    y servicios de la actividad económica de la construcción en Chile (en adelante la “Plataforma”). El
                    acceso a
                    la Plataforma se efectúa a través del Sitio Web de Iconstruye: <a href="http://www.iconstruye.com"
                        target="_blank">www.iconstruye.com</a>;
                    mediante la introducción de un nombre de usuario y una contraseña.</p>
                <p>Además del acceso a la Plataforma, Iconstruye provee servicios conexos personalizados (en adelante
                    los
                    “Servicios Asociados”), tales como tareas de implantación del sistema en los soportes del Cliente,
                    servicios
                    de capacitación e integración, soporte a los usuarios, configuración y mantención correctiva del
                    sistema, y
                    otros.</p>
                <hr>
                <h4>Los usuarios de la Plataforma Electrónica</h4>
                <p>Son usuarios de la Plataforma todas aquellas personas naturales y jurídicas que se encuentren
                    autorizadas
                    para acceder a ella, y se han registrado en el sitio a través de la introducción de su nombre de
                    usuario y
                    contraseña, proveídos por Iconstruye, y han aceptado estos Términos de Uso (en adelante el “Usuario”
                    y en
                    plural “Usuarios”).</p>
                <hr>
                <h4>Derechos de propiedad intelectual</h4>
                <p>El Usuario sabe y acepta que la Plataforma y los Servicios Asociados, así como todos sus elementos,
                    estructura, selección, ordenación y presentación de sus contenidos, y los programas utilizados en
                    relación
                    con los mismos, están protegidos por derechos de propiedad intelectual de Iconstruye o de terceros,
                    los
                    cuales deben ser respetados por él. Queda prohibida la reproducción total o parcial o uso comercial
                    del
                    formato, diagramación, o de cualquier otro elemento de la página web, o bien del contenido o
                    imágenes de la
                    Plataforma.</p>
                <hr>
                <h4>Utilización de los servicios</h4>
                <p>El Usuario declara y garantiza que es quien dice ser y que se encuentra autorizado a acceder y
                    utilizar la
                    Plataforma de IConstruye. El Usuario queda obligado a proporcionar información veraz, correcta y
                    completa, la
                    cual deberá permanecer actualizada. Esta obligación comprende tanto los datos de individualización
                    del propio
                    Usuario, como las características y precios de los productos y servicios que se publiquen en la
                    Plataforma,
                    en su caso.</p>
                <p>La información publicada en el sitio por parte de los Usuarios es de exclusiva responsabilidad de
                    éstos. En
                    consecuencia, es obligación de los Usuarios publicar información verdadera, exacta y actualizada.
                    Iconstruye
                    no se hace responsable por las ofertas, promociones u otros contenidos publicados por los Usuarios y
                    no
                    garantiza su exactitud, veracidad o autenticidad dado que no es origen o fuente de los mismos.</p>
                <p>Se encuentra prohibida la publicación de información o imágenes sin los debidos derechos o
                    autorizaciones
                    para ello, así como publicaciones contrarias a la ley, al orden público, a la moral o a las buenas
                    costumbres.</p>
                <p>El Usuario garantiza que tiene los derechos necesarios para publicar los datos, información e
                    imágenes que
                    suba al sitio, sin infringir derechos de terceros, incluidos entre otros, derechos a la privacidad,
                    derechos
                    de confidencialidad, derechos de publicidad y derechos de propiedad intelectual.</p>
                <p>El Usuario se obliga a velar por la correcta utilización del sitio y no deberá permitir que personas
                    no
                    autorizadas hagan uso del mismo. Lo anterior implica tener especial cuidado en la utilización del
                    nombre de
                    usuario y la clave secreta que tendrá para acceder a la Plataforma. En caso que el Usuario tome
                    conocimiento
                    de cualquier uso no autorizado del sitio o de su cuenta, deberá informar por escrito y en forma
                    inmediata a
                    Iconstruye, y tomar todas las demás medidas que fueren pertinentes.</p>
                <p>Iconstruye no tiene control y por lo tanto no será responsable del uso de la información contenida en
                    la
                    Plataforma que puedan hacer los Usuarios, ni de las consecuencias que pueda tener dicho uso de
                    información.
                </p>
                <p>Iconstruye se reserva el derecho de impedir o restringir el acceso a la Plataforma respecto de
                    aquéllos
                    Usuarios que incumplan con las obligaciones señaladas en estos Términos de Uso.</p>
                <hr>
                <h4>Continuidad del servicio</h4>
                <p>Iconstruye se obliga a tener a disposición de los Usuarios los servicios proporcionados a través de
                    la
                    Plataforma. En cuanto a la continuidad y confianza del sitio, el propósito es ofrecer un servicio de
                    la más
                    alta calidad y seguridad para los Usuarios. No obstante ello, no es posible garantizar la ausencia
                    de errores
                    o interrupciones en la continuidad del servicio, ni que el sitio sea inmune a todo tipo de virus o
                    componentes dañinos que puedan afectarlo. En consecuencia, Iconstruye no será responsable de los
                    perjuicios
                    que puedan ocasionarse en relación a estos riesgos o fallas, u otras similares, relacionadas con el
                    uso del
                    sitio.
                    Por razones de mantención, podrá suspenderse por algunas horas al mes el acceso a la Plataforma, lo
                    cual se
                    avisará mediante una publicación en la Plataforma con a lo menos 48 horas de anticipación, salvo en
                    aquellos
                    casos que fuere imprescindible realizarlos inmediatamente y sin previa notificación.</p>
                <hr>
                <h4>Responsabilidad en la comercialización de los bienes y servicios y almacenamiento de información.
                </h4>
                <p>Se deja claro que Iconstruye no comercializa por sí mismo los bienes y servicios transados a través
                    de la
                    Plataforma. En consecuencia, Iconstruye no será de ningún modo responsable, entre otros, de los
                    perjuicios
                    que pudieran derivarse de la falta de veracidad de la información publicada por los Usuarios, de la
                    calidad
                    de los productos y servicios ofrecidos, ni del cumplimiento o incumplimiento de las obligaciones que
                    pudieren
                    generarse a partir de la información publicada en la Plataforma o de las transacciones realizadas
                    por su
                    intermedio.</p>
                <p>Al eliminarse el contenido del sitio, no necesariamente queda eliminado de los archivos de
                    Iconstruye, sin
                    embargo, Iconstruye no asume una obligación de almacenamiento de información o imágenes, una vez que
                    éstas
                    han sido bajadas del sitio.</p>
                <hr>
                <h4>Sitios y servicios de terceros</h4>
                <p>En caso que la Plataforma permita enlazar con otros sitios web, servicios o recursos en Internet,
                    ello será
                    bajo el propio riesgo del Usuario. Estos otros sitios web no están bajo el control de Iconstruye, y
                    por tanto
                    Iconstruye no se hace responsable por el contenido, funciones, precisión, legalidad, conveniencia o
                    cualquier
                    otro aspecto de dichos sitios web o recursos. La inclusión de estos enlaces no implica aprobación
                    por parte
                    de Iconstruye ni menos asociación con sus operadores. El usuario reconoce y acepta que Iconstruye no
                    se hará
                    responsable, directa ni indirectamente, por daños o pérdidas que puedan ser causados por el uso o en
                    conexión
                    con el uso o la confianza en su contenido, productos o servicios disponibles en dicho sitio web,
                    servicio o
                    recurso, o a través de ellos.</p>
                <p>El Usuario que enlace sus publicaciones con otros sitios web, servicios o recursos, declara que tiene
                    autorización para ello, siendo el único responsable de los perjuicios que pudieran producirse en
                    caso
                    contrario.</p>
                <hr>
                <h4>Autorización</h4>
                <p>El Usuario autoriza a Iconstruye para utilizar sus datos o la información relativa a las
                    transacciones
                    efectuadas, para la producción y divulgación de información estadística, indicadores del sector,
                    participación de mercado, y otros. Asimismo, Iconstruye desarrolla negocios con otros agentes del
                    mercado e
                    impulsa iniciativas que pueden beneficiar a los usuarios o clientes de la plataforma. En este
                    sentido el
                    Usuario, en conformidad con la ley 19.628, autoriza a Iconstruye a entregar sus datos y la
                    información de las
                    transacciones que se realicen, con el objeto que Iconstruye, sus empresas relacionadas u otras,
                    puedan
                    ofrecer productos, servicios u oportunidades de negocios que estimen que puedan ser de interés.</p>
                <hr>
                <h4>Personería</h4>
                <p>Quien acepta estos Términos y Condiciones, declara bajo juramento que es quien dice ser. Asimismo, en
                    caso
                    de actuar en representación de una persona jurídica, también declara bajo juramento que tiene todas
                    las
                    facultades necesarias para representarla y las atribuciones que le permiten aceptar estos Términos y
                    Condiciones.</p>
                <p>En el evento que se incumpla lo indicado en el párrafo precedente, el Usuario se hace responsable de
                    todos
                    los perjuicios que ello pueda ocasionar a terceros o a Iconstruye e incluso responderá penalmente si
                    fuese el
                    caso.</p>
                <hr>
                <h4>Ley aplicable</h4>
                <p>Los presentes términos de uso se regirán por la ley chilena fijándose como domicilio la comuna y
                    ciudad de
                    Santiago.</p>

            </div>
            <div class="modal-footer">
                <a class="btn btn-default btn-sm" (click)="closeModal()">Cerrar</a>
                <button class="btn btn-success btn-sm mensaje-aceptar-terminos" (click)="onAcceptTerms()"
                    data-dismiss="modal">Aceptar</button>
            </div>
        </div>
    </div>
</div>